module.exports = __webpack_public_path__ + "static/img/info_icon.45f9eb37.svg";